import React, { Suspense } from 'react'
import { ChatAssistant, ChatMessage } from '../../types'

const ConfirmationCore = React.lazy(() => import('./Confirmation/Confirmation'))

export default function Confirmation({
  blockType,
  content,
  assistant,
  message
}: {
  blockType: string
  content: string
  assistant?: ChatAssistant
  message?: ChatMessage
}) {
  return (
    <Suspense fallback={null}>
      <ConfirmationCore blockType={blockType} content={content} assistant={assistant} message={message} />
    </Suspense>
  )
}
